import $ from 'jquery';
import debounce from './utils/debounce';
import CssVar from './utils/css-var';

class FullHeight {
    constructor () {
        this.$window = $(window);
        this.$root = $(':root');

        this.$window.on('load resize scroll', debounce(() => {
            this.setStyle();
        }, 50));
    }

    setStyle () {
        const vh = window.innerHeight * 0.01;
        CssVar('full-height', `${vh}px`);
    }
}

export default FullHeight;
